import { displayLatLonInCompassFormat } from '@deckee/utilities';
import React from 'react';
import { thunder } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Overhead cable or power lines',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'overhead-cable',
  icon: {
    baseShape: thunder,
    iconColor: '#fff',
    markerColor: '#E28D18',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'safety',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType: 'overheadCableMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Overhead cable or power lines',
      itemTitleFunction: (item) =>
        (item &&
          item.geoJson &&
          item.geoJson.properties &&
          (item.geoJson.properties.title || item.geoJson.properties.bar)) ||
        'Overhead cable or power lines',
    },
    creationOptions: {
      menuText: 'Overhead cable or power lines',
      newTitle: 'Overhead cable',
      titlePlaceholder: 'Name of marker',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker is used to indicate an overhead cable or power lines.
          Include information such as factors to be aware of, potential
          concerns, or any caution to be advised.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: false,
    title: 'Overhead cable or power lines',
    description:
      marker && marker.geoJson && marker.geoJson.properties
        ? marker.geoJson.properties.bar
        : displayLatLonInCompassFormat(marker.latLon),
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
